export interface menuType {
  title: string;
  path: string;
  children?: menuType[][];
}

const MenuOptions: menuType[] = [
  {
    title: "首页",
    path: "/home",
  },
  {
    title: "解决方案",
    path: "/solution/index",
  },
  {
    title: "产品",
    path: "/product/index",
  },
  {
    title: "客户案例",
    path: "/customerCase",
  },
  {
    title: "新闻",
    path: "/news/index",
  },
  {
    title: "合作生态",
    path: "/cooperativeEcosystem",
  },
  {
    title: "关于我们",
    path: "/aboutUs",
  },
];

export default MenuOptions;
